export const cars =[
    {
        image: "/images/toyota_prado/1.jpg",
        // title: "Toyota Prado"
    },
    {
        image: "/images/toyota_prado/2.jpg",
        // title: "Toyota Prado"
    },
    {
        image: "/images/toyota_prado/3.jpg",
        // title: "Toyota Prado"
    },
    {
        image: "/images/toyota_prado/4.jpg",
        // title: "Toyota Prado"
    },
    {
        image: "/images/toyota_prado/5.jpg",
        // title: "Toyota Prado"
    }
];